<template>
  <div class="service-detail-section">
    <div>
      <div class="grid-column ai-s jc-s gap-10">
        <img
          src="@shared/assets/img/service/build.svg"
          class="img-size-20"
          alt="type"
        >
        <div class="sac__font-16 semi-bold">
          {{ service.serviceLabel }}:
        </div>
        <div class="sac__font-16">
          {{ service.type }}
        </div>
      </div>
      <div class="grid-column ai-s jc-s gap-10 margin-top-24">
        <img
          src="@shared/assets/img/service/calendar.svg"
          class="img-size-20"
          alt="date"
        >
        <div class="sac__font-16 semi-bold">
          {{ service.dateLabel }}:
        </div>
        <div class="sac__font-16">
          {{ serviceRequestDate }}
        </div>
      </div>
      <div
        v-if="!isServiceScheduled"
        class="grid-column ai-s jc-s gap-10 margin-top-24"
      >
        <img
          src="@shared/assets/img/service/calendar.svg"
          class="img-size-20"
          alt="date"
        >
        <div class="sac__font-16 semi-bold">
          Backup Date:
        </div>
        <div class="sac__font-16">
          {{ backupRequestDate }}
        </div>
      </div>
      <div class="grid-column ai-s jc-s gap-10 margin-top-24">
        <img
          src="@shared/assets/img/service/flag-outline.svg"
          class="img-size-20"
          alt="text"
        >
        <div class="sac__font-16 semi-bold">
          Issues Reported:
        </div>
        <div class="sac__font-16">
          {{ serviceItem.serviceIssues || '--' }}
        </div>
      </div>
      <div class="grid-column ai-s jc-s gap-10 margin-top-24">
        <img
          src="@shared/assets/img/service/edit-white.svg"
          class="img-size-20"
          alt="note"
        >
        <div class="sac__font-16 semi-bold">
          Customer Notes:
        </div>
        <div class="sac__font-16">
          {{ serviceItem.customerNotes || '--' }}
        </div>
      </div>
    </div>
    <div>
      <div
        v-if="serviceInfo.invoiceUrl && serviceInfo.invoiceUrl !== '' && activeTab === 'closed'"
        class="grid-column ai-s jc-s gap-10 "
      >
        <img
          src="@shared/assets/img/service/invoice.svg"
          class="img-size-20"
          alt="tech"
        >
        <div class="sac__font-16 semi-bold">
          Invoice:
        </div>
        <button
          type="button"
          class="sac__font-16 f-sunset underline"
          @click="toggleActionModal(true, 'invoice')"
        >
          invoice.pdf
        </button>
      </div>
      <div
        v-else-if="activeTab === 'closed'"
        class="grid-column ai-s jc-s gap-10 "
      >
        <img
          src="@shared/assets/img/service/invoice.svg"
          class="img-size-20"
          alt="tech"
        >
        <div class="sac__font-16 semi-bold">
          Invoice:
        </div>
        <button
          type="button"
          class="sac__font-16 f-sunset underline"
          @click="toggleActionModal(true, 'invoice')"
        >
          Upload Invoice
        </button>
      </div>
      <div class="grid-column ai-s jc-s gap-10 margin-top-16">
        <img
          src="@shared/assets/img/service/build.svg"
          class="img-size-20"
          alt="tech"
        >
        <div class="sac__font-16 semi-bold">
          Technician:
        </div>
        <div class="sac__font-16">
          {{ serviceItem.technician || serviceItem.assignedTech || '--' }}
        </div>
      </div>
      <div class="grid-column ai-s jc-s gap-10 margin-top-16">
        <img
          src="@shared/assets/img/service/shipping.svg"
          class="img-size-20"
          alt="branch"
        >
        <div class="sac__font-16 semi-bold">
          Branch:
        </div>
        <div class="sac__font-16">
          {{ serviceItem.assignedCorp || serviceItem.corpName }}
        </div>
      </div>
      <div class="grid-column ai-s jc-s gap-10 margin-top-16">
        <img
          src="@shared/assets/img/service/award.svg"
          class="img-size-20"
          alt="plan"
        >
        <div class="sac__font-16 semi-bold">
          Plan Type:
        </div>
        <div class="sac__font-16">
          {{ serviceItem.planTier || '--' }}
        </div>
      </div>
      <div
        v-if="externalIntegration"
        class="grid-column ai-s jc-s gap-10 margin-top-16"
      >
        <img
          src="@shared/assets/img/service/integrate.svg"
          class="img-size-20"
          alt="int"
        >
        <div class="sac__font-16 semi-bold">
          {{ externalIntegration.source }}:
        </div>
        <div class="sac__font-16">
          {{ externalIntegration.status }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import serviceMixin from '@shared/mixins/serviceMixin';
import ActionStatus from '@shared/lib/constant/ActionStatus';

export default {
  name: 'ServiceDetailSummary',
  mixins: [serviceMixin],
  props: {
    serviceItem: Object,
  },
  computed: {
    backupRequestDate() {
      const {
        additionalDate,
        additionalTimes,
      } = this.serviceItem;
      if (additionalDate && additionalTimes) {
        const day = moment(additionalDate).format('ll').split(',')[0];
        return `${day} at ${additionalTimes.substring(0, 10)}`;
      }
      return '--';
    },
    isServiceScheduled() {
      const {
        serviceStatus,
        jobId,
      } = this.serviceItem;
      return (this.scheduledStatus.includes(serviceStatus) || jobId);
    },
    service() {
      const {
        serviceCategory,
        serviceType,
        serviceStatus,
      } = this.serviceItem;
      let serviceLabel = 'Request Type';
      let dateLabel = 'Requested Date';
      if (this.isServiceScheduled) {
        serviceLabel = 'Job Type';
        dateLabel = 'Scheduled Date';
      } else if (serviceStatus === ActionStatus.Completed) {
        dateLabel = 'Completed Date';
      }
      return {
        serviceLabel,
        dateLabel,
        type: `${serviceCategory} ${serviceType}`,
      };
    },
    serviceRequestDate() {
      const {
        serviceStatus,
        confirmedDate,
        confirmedTime,
        scheduleDate,
        scheduleTime,
        requestedDate,
        requestedTimes,
        completedDate,
      } = this.serviceItem;
      let date = requestedDate;
      let times = requestedTimes;
      if (serviceStatus === ActionStatus.Completed) {
        return moment(completedDate).format('ll');
      }
      if (this.isServiceScheduled) {
        date = scheduleDate || confirmedDate;
        times = scheduleTime || confirmedTime;
        let timeOfTheDay;
        if (date && times) {
          timeOfTheDay = moment(date).startOf('day').add(times, 'hours').format('HH:mm a');
        }
        const day = moment(date).format('ll').split(',')[0];
        return `${day} at ${timeOfTheDay}`;
      }
      if (date && times) {
        const day = moment(date).format('ll').split(',')[0];
        return `${day} between ${times}`;
      }
      return '--';
    },
    externalIntegration() {
      const {
        externalStatus,
        externalSource,
      } = this.serviceItem;
      if (externalSource) {
        return {
          source: externalSource,
          status: externalStatus,
        };
      }
      return false;
    },
  },
  methods: {
    async showInvoice(url) {
      const res = await this.$store.dispatch('getInvoiceResponse', url);
      const response = await fetch(res);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      window.open(blobUrl, '_blank');
      setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
    },
  },
};
</script>
<style lang="scss" scoped>
.service-detail-section {
  background-color: $N90;
  border-radius: 8px;
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  color: $WHITE;
}
</style>
